<!--
2022-09-26 Matt 申请成为代理
-->
<template>
  <div class="agentApplyPage">
    <TopBack :title="$t('lang.agent.apply')"/>
    <div class="applyForm">
      <div class="fields">
        <div class="label">
          {{ $t('lang.agent.name') }}
        </div>
        <div class="field">
          <input
            type="text"
            name="Name"
            :maxlength="64"
            :placeholder="$t('lang.agent.name')"
            @input="validateName"
            v-model="agentInfo.Name"
          >
          <span class="validationErrorMessage">
            {{ NameValidationErrorMessage }}
          </span>
        </div>
      </div>

      <div class="fields">
        <div class="label">
          {{ $t('lang.agent.email') }}
        </div>
        <div class="field">
          <input
            type="text"
            name="email"
            :maxlength="64"
            :placeholder="$t('lang.agent.email')"
            @input="validateEmail"
            v-model="agentInfo.email"
          >
          <span class="validationErrorMessage">
            {{ emailValidationErrorMessage }}
          </span>
        </div>
      </div>

      <div class="fields">
        <div class="label">
          {{ $t('lang.agent.mobileNumber') }}
        </div>
        <div class="field" id="mobileNumber">
          <input
            type="text"
            name="mobileNumber"
            :maxlength="64"
            :placeholder="$t('lang.agent.mobileNumber')"
            @input="validateMobileNumber"
            v-model="agentInfo.mobileNumber"
          >
        </div>
        <span class="validationErrorMessage">
          {{ mobileNumberValidationErrorMessage }}
        </span>
      </div>

      <div class="fields">
        <div class="label">
          {{ $t('lang.agent.smsCode') }}
        </div>
        <div class="field" id="smsCode">
          <input
            type="text"
            name="smsCode"
            :maxlength="8"
            :placeholder="$t('lang.agent.smsCode')"
            @input="validateSMSCode"
            v-model="agentInfo.smsCode"
          >
          <button
            @click="sendSMSCode"
            :disabled="isSendSMSCodeButtonDisabled || isSMSButtonJustSent"
            :class="{ disabled: isSendSMSCodeButtonDisabled || isSMSButtonJustSent }"
          >
            {{ isSMSButtonJustSent ? counter : $t('lang.agent.send') }}
          </button>
        </div>
        <span class="validationErrorMessage">
          {{ smsCodeValidationErrorMessage }}
        </span>
      </div>
      <div class="validationErrorMessage" v-show="submitted">
        {{ validationErrorMessage }}
      </div>
      <button
        class="submitButton"
        :disabled="isSubmitButtonDisabled"
        :class="{ disabled: isSubmitButtonDisabled }"
        @click="submitForm"
      >
        {{ $t('lang.agent.submit') }}
      </button>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import { Toast } from 'mint-ui'

export default {
  name: 'AgentApply',
  data () {
    return {
      agentInfo: {},
      NameValidationErrorMessage: '',
      emailValidationErrorMessage: '',
      mobileNumberValidationErrorMessage: '',
      smsCodeValidationErrorMessage: '',
      submitted: false,
      isSMSButtonJustSent: false,
      counter: 60
    }
  },
  components: {
    TopBack
  },
  computed: {
    isSendSMSCodeButtonDisabled: function () {
      return !this.agentInfo.mobileNumber || this.mobileNumberValidationErrorMessage !== ''
    },
    isSubmitButtonDisabled: function () {
      return !this.agentInfo.Name ||
        !this.agentInfo.email ||
        !this.agentInfo.mobileNumber ||
        !this.agentInfo.smsCode ||
        this.NameValidationErrorMessage !== '' ||
        this.mobileNumberValidationErrorMessage !== '' ||
        this.smsCodeValidationErrorMessage !== '' ||
        this.emailValidationErrorMessage !== ''
    },
    validationErrorMessage: function () {
      return this.NameValidationErrorMessage ||
        this.mobileNumberValidationErrorMessage ||
        this.smsCodeValidationErrorMessage ||
        this.emailValidationErrorMessage
    }
  },
  watch: {},
  mounted () {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.agentInfo.UserUniqueId = userInfo.UserId
    this.fetchAccount()
  },
  methods: {
    fetchAccount () {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo) {
        const that = this
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: userInfo.UserId
        }
        request('post', url, data).then(res => {
          const accountInfo = res
          if (accountInfo.IsAgent) {
            Toast({ message: this.$t('lang.agent.applyDuplicated'), duration: 5000 })
            setTimeout(function () {
              that.$router.push('/Agent')
            }, 6000)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    validateName: function (e) {
      const Name = e.target.value
      if (Name.length >= 3 && Name.length <= 64) {
        this.NameValidationErrorMessage = ''
      } else {
        this.NameValidationErrorMessage = 'please enter correct name, 3 ~ 64 characters'
      }
    },
    validateMobileNumber: function (e) {
      const mobileNumber = e.target.value
      const mobileNumberPattern = /^[6-9]\d{9}$/
      if (mobileNumber === '' || mobileNumberPattern.test(mobileNumber)) {
        this.mobileNumberValidationErrorMessage = ''
      } else {
        this.mobileNumberValidationErrorMessage = 'please enter correct mobile number'
      }
    },
    validateSMSCode: function (e) {
      const smsCode = e.target.value
      const smsCodePattern = /^\d{4}$/
      if (smsCode === '' || smsCodePattern.test(smsCode)) {
        this.smsCodeValidationErrorMessage = ''
      } else {
        this.smsCodeValidationErrorMessage = 'please enter correct SMS code'
      }
    },
    validateEmail: function (e) {
      const email = e.target.value
      const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
      if (email === '' || emailPattern.test(email)) {
        this.emailValidationErrorMessage = ''
      } else {
        this.emailValidationErrorMessage = 'please enter correct email'
      }
    },
    reverseCounter: function () {
      const that = this
      setTimeout(function () {
        if (that.counter > 0) {
          that.counter -= 1
          that.reverseCounter()
        } else {
          that.isSMSButtonJustSent = false
        }
      }, 1000)
    },
    sendSMSCode: function () {
      if (!this.agentInfo.mobileNumber || this.mobileNumberValidationErrorMessage !== '') {
        return false
      }
      const that = this
      this.isSMSButtonJustSent = true
      this.reverseCounter()

      request('post', '/innovation/agent/sendSmsCode', { CountryCode: '91', Mobile: this.agentInfo.mobileNumber })
        .then(res => {
          if (res) {
            Toast({ message: this.$t('lang.agent.smsCodeSentSuccess'), duration: 5000 })
          } else {
            Toast({ message: this.$t('lang.agent.smsCodeSentTooFrequent'), duration: 5000 })
          }
          that.counter = 60
        })
        .catch(() => {
          Toast({ message: this.$t('lang.agent.smsCodeSentFailed'), duration: 5000 })
          that.counter = 60
        })
    },
    submitForm: function () {
      const that = this
      this.submitted = true
      request('post', '/innovation/agent/apply', this.agentInfo)
        .then(res => {
          if (res === 'DUPLICATED') {
            Toast({ message: this.$t('lang.agent.applyDuplicated'), duration: 5000 })
          } else if (res === 'INCORRECT_SMS_CODE') {
            Toast({ message: this.$t('lang.agent.incorrectSMSCode'), duration: 5000 })
          } else {
            Toast({ message: this.$t('lang.agent.applySuccess'), duration: 5000 })
            setTimeout(function () {
              that.$router.push('/home')
            }, 6000)
          }
        })
        .catch(() => {
          Toast({ message: this.$t('lang.agent.applyFailed'), duration: 5000 })
        })
    }
  }
}
</script>

<style lang="less" scoped>
  .agentApplyPage {
    padding:56px 0 70px 0;
    background-color: rgba(0,0,0,.9);
    height: 98vh;
    overflow-y: hidden;

    .applyForm {
      padding: 30px 20px;

      .fields {
        margin-bottom: 32px;

        .label {
          font-size: 18px;
          line-height: 22px;
          color: #F6D9AA;
          margin-bottom: 8px;
        }

        .field {
          input {
            width: 100%;
            font-size: 16px;
            color: #fff;
            text-align: left;
            line-height: 38px;
            padding: 2px 6px;
            border: 1px solid rgba(246, 217, 170, 0.5);
            border-radius: 6px;
          }
        }

        #mobileNumber {
          display: flex;

          input {
            width: 88%;
            border-radius: 0 6px 6px 0;
          }

          &::before {
            content: '+91';
            width: 12%;
            line-height: 42px;
            text-align: center;
            color: #ffffff;
            border: 1px solid rgba(246, 217, 170, 0.5);
            border-radius: 6px 0 0 6px;
          }
        }

        #smsCode {
          display: flex;
          justify-content: space-between;

          input {
            width: 68%;
            border-radius: 6px;
          }

          button {
            background: #F6D9AA;
            color: black;
            width: 28%;
            font-size: 16px;
            font-weight: 400;
            border: 1px solid #F6D9AA;
            border-radius: 6px;
          }
        }
      }

      .validationErrorMessage {
        display: block;
        font-size: 14px;
        color: #ff2b4d;
        margin: 10px 0 20px;
      }

      .disabled {
        color: #c6c6c6!important;
        background: #EBEBE4!important;
      }

      .submitButton {
        background: #F6D9AA;
        color: black;
        width: 100%;
        font-size: 18px;
        font-weight: 400;
        border: 1px solid #F6D9AA;
        border-radius: 6px;
        line-height: 42px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Agent/apply.vue